module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_012.png
// module id = 2359
// module chunks = 5